var _defs, _line, _g, _g2, _g3, _g4, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeatoreWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.8 71.96",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.9,
    y1: 2,
    x2: 27.9,
    y2: 5.64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.44,
    y1: 8.31,
    x2: 12.71,
    y2: 10.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.36,
    y1: 8.31,
    x2: 43.09,
    y2: 10.58
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2,
    y1: 23.87,
    x2: 5.64,
    y2: 23.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50.16,
    y1: 23.87,
    x2: 53.8,
    y2: 23.87
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.12,54.06v-7.54c0-1.54-.79-2.99-2.14-3.73-5.74-3.15-9.43-9.69-8.57-16.83.96-7.94,7.66-14.14,15.65-14.53,9.56-.48,17.47,7.14,17.47,16.6,0,6.32-3.45,11.91-8.63,14.74-1.4.77-2.31,12.2-2.29,13.8l-.04,8.98s-6.7,1.24-8.62,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25.97,54.06c0,2.13-1.73,3.85-3.85,3.85s-3.85-1.73-3.85-3.85c0-2.13,1.73-3.85,3.85-3.85,2.13,0,3.85,1.73,3.85,3.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.9 66.82 28.62 61.56 25.62 66.77 28.66 71.96 15.9 66.82"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.49,
    y1: 24.62,
    x2: 24.53,
    y2: 36.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.31,
    y1: 24.62,
    x2: 31.28,
    y2: 36.54
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.12,
    y1: 27.33,
    x2: 34.69,
    y2: 27.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeatoreWhite);
export default __webpack_public_path__ + "static/media/ideatore-white.6bfbc519504500537f6ca271bf8a672e.svg";
export { ForwardRef as ReactComponent };